import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

const AsSeenOn = () => {
  const images = [
    `/images/interviewed/WFAA.webp`,
    `/images/interviewed/NBC5.webp`,
    `/images/interviewed/Ksat12.webp`,
    `/images/interviewed/CBSAustin.webp`,
    `/images/interviewed/Kens5.webp`,
    `/images/interviewed/News4sa.webp`,
    `/images/interviewed/SAlive.webp`,
    `/images/interviewed/KXAN.webp`,
    `/images/interviewed/KHOU.webp`,
  ];

  return (
    <div className="bg-gray-100 py-10 px-4">
      <h2 className="text-xl sm:text-3xl text-center font-bold mx-auto mb-8 text-sky-700 uppercase">
        regularly interviewed on these stations and more:
      </h2>
      <Swiper
        className="sm:!hidden"
        pagination={{
          clickable: true,
          el: ".as-seen-on-swiper-pagination",
          renderBullet: function (index, className) {
            return (
              '<span class="!h-2.5 !w-2.5 rounded-full m-2 top-0 right-0 mr-2 bg-gray-600 ' +
              className +
              '"></span>'
            );
          },
        }}
        autoplay={false}
        speed={500}
        modules={[Pagination, Autoplay]}
        slidesPerView={1}
        spaceBetween={28}
      >
        <SwiperSlide className="mb-8">
          <div className="flex flex-col items-center justify-center">
            {images.slice(0, 3).map((url, index) => (
              <img
                className="w-44"
                width={176}
                key={index}
                src={url}
                alt="Logo"
              />
            ))}
          </div>
        </SwiperSlide>
        <SwiperSlide className="mb-8">
          <div className="flex flex-col items-center justify-center">
            {images.slice(3, 6).map((url, index) => (
              <img
                className="w-44"
                width={176}
                key={index}
                src={url}
                alt="Logo"
              />
            ))}
          </div>
        </SwiperSlide>
        <SwiperSlide className="mb-8">
          <div className="flex flex-col items-center justify-center">
            {images.slice(6, 9).map((url, index) => (
              <img
                className="w-44"
                width={176}
                key={index}
                src={url}
                alt="Logo"
              />
            ))}
          </div>
        </SwiperSlide>
      </Swiper>
      <Swiper
        className="max-sm:!hidden"
        pagination={{
          clickable: true,
          el: ".as-seen-on-swiper-pagination",
          renderBullet: function (index, className) {
            return (
              '<span class="!h-2.5 !w-2.5 rounded-full m-2 top-0 right-0 mr-2 bg-gray-600 ' +
              className +
              '"></span>'
            );
          },
        }}
        speed={500}
        slidesPerView={3}
        breakpoints={{
          768: {
            slidesPerView: 6,
          },
          500: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        }}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        spaceBetween={28}
      >
        {images.map((url, index) => (
          <SwiperSlide className="mb-8" key={index}>
            <img className="w-44" width={176} src={url} alt="Logo" />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="as-seen-on-swiper-pagination flex justify-center sm:hidden" />
    </div>
  );
};

export default AsSeenOn;
